import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Industry_sector_child entries
 */
export const fetchIndustry_sector_childItems = createAsyncThunk(
  "industry_sector_child/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/industry_sector_child`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
